import { render } from "./RecipientTechnicalDetails.vue?vue&type=template&id=3479f534&scoped=true&ts=true"
import script from "./RecipientTechnicalDetails.vue?vue&type=script&lang=ts"
export * from "./RecipientTechnicalDetails.vue?vue&type=script&lang=ts"

import "./RecipientTechnicalDetails.vue?vue&type=style&index=0&id=3479f534&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3479f534"]])

export default __exports__